import { Modal } from 'src/components/Modal';
import { Button } from 'src/components/Button';

type DeleteOverrideModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  formattedDate: string;
};

export const DeleteOverrideModal = ({
  isOpen,
  onClose,
  onConfirm,
  formattedDate,
}: DeleteOverrideModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete date override"
      actionButton={
        <Button onClick={onConfirm} variant="contained" color="error">
          Delete
        </Button>
      }
    >
      <p>
        Are you sure you want to delete the date override for{' '}
        <span className="font-medium">{formattedDate}</span>?
      </p>
    </Modal>
  );
};

export default DeleteOverrideModal;
